import { IApplicationState } from '../../types/redux';

export function selectPageOptions(state: IApplicationState) {
  return state.pagination.pageOptions;
}
